// extracted by mini-css-extract-plugin
var _1 = "PostListContainer-modulePostListContainer__XytUW";
export { _1 as "PostListContainer" }
